
import {defineComponent, onMounted, ref, h} from 'vue';
import {OioButton, OioDateTimePicker, OioForm, OioFormItem, OioModal, OioSwitch} from '@kunlun/vue-ui-antd';
import {ElDialog, ElProgress} from 'element-plus'
import {MinusCircleOutlined, PlusCircleOutlined} from "@ant-design/icons-vue";

export default defineComponent({
  name: 'customizeView',
  inheritAttrs: false,
  components: {
    OioSwitch,
    PlusCircleOutlined,
    MinusCircleOutlined,
    OioButton, OioDateTimePicker, OioForm, OioFormItem, OioModal,ElDialog,ElProgress},
  props: {
    exportFile: {
      type: Function,
      required: true
    },
    getExportProgress: {
      type: Function,
      required: true
    },
  },
  setup(props) {
    const visible = ref(false);
    let percentage = ref(0);
    // const notify = ref<Record<string, any>>({})



    const cancel = () => {
      visible.value = false;
    }
    const submit = () => {
      const id = Date.now()
      visible.value = true
      const int = setInterval(async () => {
        try {
          const res = await props.getExportProgress(id);
          if(res.total === 0)
            return;
          const newPercentage = res.total === 0 ? 0 : (res.export / res.total) * 100;
          percentage.value = newPercentage;
        } catch (err) {
          console.error('获取进度失败', err);
          clearInterval(int);
        }
      }, 1000);

      props.exportFile(id).then(res => {
        console.log(res);
        clearInterval(int);
        percentage.value = 100
        const link = document.createElement('a');
        link.href = res;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // window.open(res);
      }).finally(() => {
        clearInterval(int)
        setTimeout(() => { cancel() },1000)
      });
    }


    onMounted(() => {
    });


    return {
      submit,
      visible,
      cancel,
      percentage
    };
  }
});
